import { setContext } from '@apollo/client/link/context';
import type { namedOperations } from '~api/graphql';
import { useHostProps, type HostPropsContextValue } from '~features/host-props';

type CreateAuthLinkOptions = Partial<Pick<HostPropsContextValue, 'getAuthToken'>>;

const PUBLIC_OPERATIONS: (keyof (typeof namedOperations)['Query'])[] = [
  'AtlasUser',
  'CompanyProfilePublic',
  'CompanyProfilePublicSlug',
  'CompanyProfileJobAd',
  'CompanyProfileEmployerSegment',
  'CompanyProfileJobOffers',
  'CompanyProfileCarousel',
  'CompanyProfileListing',
];

export const ANONYMOUS_TOKEN = 'ANONYMOUS';

export const createAuthLink = ({ getAuthToken }: CreateAuthLinkOptions = {}) =>
  setContext(async (operation) => {
    const isPublicOperation = PUBLIC_OPERATIONS.includes(
      (operation.operationName as keyof (typeof namedOperations)['Query']) ?? '',
    );

    return {
      headers: {
        Authorization: isPublicOperation
          ? ANONYMOUS_TOKEN
          : (await getAuthToken?.()) ?? ANONYMOUS_TOKEN,
      },
    };
  });

export const useAuthLink = () => {
  const { getAuthToken } = useHostProps();

  return createAuthLink({ getAuthToken });
};
